import { render, staticRenderFns } from "./comp_ImageMagnifier.vue?vue&type=template&id=44a26dd6&scoped=true"
import script from "./comp_ImageMagnifier.vue?vue&type=script&lang=js"
export * from "./comp_ImageMagnifier.vue?vue&type=script&lang=js"
import style0 from "./comp_ImageMagnifier.vue?vue&type=style&index=0&id=44a26dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a26dd6",
  null
  
)

export default component.exports